{
  "en": {
    "milestone": {
      "actions": {
        "activate": "Activate",
        "active": "Active!",
        "create": "Create milestone",
        "deactivate": "Deactivate",
        "delete": "Delete",
        "delete_milestones": "Delete milestone | Delete {count} milestones",
        "new": "Milestone"
      },
      "activate": {
        "confirm": "Activate",
        "intro": "Activating this milestone will:",
        "past_warning": "Going back to an earlier milestone won't undo what already happened. Anything shared with customers will not automatically be revoked.",
        "title": "Activate milestone",
        "verb_default": "Trigger",
        "verb_share": "Share"
      },
      "attach": {
        "add": "Add",
        "add_kind": "Add {kind}",
        "assigned_tag": "Assigned",
        "back": "Back",
        "counts": "{available} available · {assigned} already assigned",
        "description_decision": "Choices the customer has to make",
        "description_survey": "Questionnaires to collect input",
        "empty": "No elements available",
        "empty_state_description": "Based on your plan you can add {kinds} to this milestone.",
        "intro": "Choose which type of element you want to link to this milestone.",
        "next": "Next",
        "search": "Search",
        "select_intro": "Select the {kind} you want to add.",
        "subtitle": "To milestone: {name}",
        "success": "Elements added",
        "title": "Add elements"
      },
      "labels": {
        "add_element": "Add element",
        "add_kind": "Add {kind}",
        "assign_units": "Assign units",
        "assigned_count": "0 assigned | 1 assigned | {count} assigned",
        "assigned_elements": "Assigned elements",
        "assigned_empty_description": "Attach {kinds} to this milestone",
        "assigned_empty_title": "No elements yet",
        "bulk_assign_title": "Select units you want to assign milestone '{milestone_name}' to",
        "edit_milestone": "Edit milestone",
        "empty_state_subtitle": "Milestones make the building process more transparent for homebuyers",
        "empty_state_title": "Create a new milestone",
        "finished_on": "Finished {date}",
        "future_milestones": "Future milestones",
        "kind_decision": "Decision | Decisions",
        "kind_survey": "Survey | Surveys",
        "kind_todo": "Task | Tasks",
        "milestone": "Milestone",
        "milestone_name": "Milestone name",
        "milestone_unit_count": "0 units | 1 unit | {count} units",
        "milestones": "Milestones",
        "new_milestone": "New milestone",
        "no_milestone": "No milestone assigned yet",
        "no_results": "No milestones found",
        "past_milestones": "Past milestones",
        "please_select": "Please select a new milestone",
        "position": "Position",
        "search_empty_state": "No milestones created yet. Click here to start",
        "started_on": "Started {date}",
        "status_active": "Active",
        "status_completed": "Completed",
        "status_planned": "Planned",
        "status_planned_subtitle": "Not started yet",
        "unit_timeline_empty": "No milestones have been created for this project yet.",
        "units": "Units",
        "units_without_milestone": "1 unit without milestone | {count} units without milestone",
        "warning_delete": "If you delete a milestone that has been assigned to a unit, the customer will lose sight of what milestone their unit is at. Be sure to assign a new milestone to these units!"
      },
      "toasts": {
        "bulk_assigned": "The milestone is successfuly assigned to the selected units",
        "create_success": "Milestone successfully created",
        "deactivate_success": "Milestone has been successfully deactivated",
        "sup_assigned": "The milestone is successfuly activated",
        "update_success": "Milestones have been successfully updated"
      },
      "validation": {
        "needName": "Name required",
        "needNamePrimary": "The primary language ({language}) name is required"
      }
    }
  }
}
